import { Suspense, lazy, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import {
  Routes,
  Route,
  useLocation,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { DashboardLayout } from "../layout/DashboardLayout";
import Cookies from "js-cookie";
import ManageLatter from "../Pages/ManageLatter";
import ViewLatterDetails from "../Pages/ManageLatter/ViewLatterDetails";
import EditLatter from "../Pages/ManageLatter/EditLatter";
import AddLatter from "../Pages/ManageLatter/addLatter";
import ManageLadderLetter from "../Pages/ManageLadderLetter";
import AddLadderLetter from "../Pages/ManageLadderLetter/AddLadderLetter";
import EditLadderLetter from "../Pages/ManageLadderLetter/EditLadderLetter";
import ManageNumber from "../Pages/ManageNumber";
import ViewNumberDetails from "../Pages/ManageNumber/ViewNumberDetails";
import EditNumber from "../Pages/ManageNumber/EditNumber";
import AddNumber from "../Pages/ManageNumber/addNumber";
import ManageWord from "../Pages/ManageWord";
import AddWord from "../Pages/ManageWord/addWord";
import EditWord from "../Pages/ManageWord/EditWord";
import ViewWordDetails from "../Pages/ManageWord/ViewLatterDetails";
import ViewSentenceDetails from "../Pages/ManageSentence/ViewSentenceDetails";
import ManageSentence from "../Pages/ManageSentence";
import EditSentence from "../Pages/ManageSentence/EditSentence";
import AddSentence from "../Pages/ManageSentence/addSentence";
import ManageCategory from "../Pages/ManageCategory";
import ViewCategoryDetails from "../Pages/ManageCategory/ViewCategoryDetails";
import EditCategory from "../Pages/ManageCategory/EditCategory";
import AddCategory from "../Pages/ManageCategory/addCategory";
import ViewLadderLetterDetails from "../Pages/ManageLadderLetter/ViewLadderLetterDetails";
import ManageTournament from "../Pages/ManageTournament";
import ViewTournamentDetails from "../Pages/ManageTournament/ViewTournamentDetails/index";
import EditTournament from "../Pages/ManageTournament/EditTournament";
import AddTournament from "../Pages/ManageTournament/addTournament";
import AboutUs from "../Pages/AboutUs";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import CancellationAndRefund  from "../Pages/CancellationAndRefund";
import TermsCondition from "../Pages/TermCondition";
import FAQ from "../Pages/FAQ";
import ManageChallenge from "../Pages/ManageChallenges";
import ViewChallengeDetails from "../Pages/ManageChallenges/ViewChallengeDetails";
import EditChallenge from "../Pages/ManageChallenges/EditChallenge";
import AddChallenge from "../Pages/ManageChallenges/addChallenge";
import ManageBadge from "../Pages/Badge";
import EditBadge from "../Pages/Badge/EditBadge";
import AddBadge from "../Pages/Badge/addBadge";
import ManageTeacher from "../Pages/ManageTeacher";
import ManageSchool from "../Pages/ManageSchool";
import ViewSchoolDetails from "../Pages/ManageSchool/ViewSchoolDetails";
import ViewTeacherDetails from "../Pages/ManageTeacher/ViewTeacherDetails";
import ManageBlog from "../Pages/Blog";
import EditBlog from "../Pages/Blog/EditBlog";
import AddBlog from "../Pages/Blog/addBlog";
import ForgotPasswordEmail from "../Pages/ForgotPasswordEmail";
import ManageSubAdmin from "../Pages/SubAdmin";
import EditSubAdmin from "../Pages/SubAdmin/EditSubAdmin";
import AddSubAdmin from "../Pages/SubAdmin/AddSubAdmin";
import PermissionNotHave from "../component/PermissionNotHave";
import { PermissionContext } from "../context/PermissionContext";
import Leaderboard from "../Pages/Leaderboard";
import ContectUsReplay from "../Pages/ManageContact/ContectUsReplay";
import TurnamentLeaderboard from "../Pages/ManageTournament/TournamentLeaderBoard";
import ViewBlogDetails from "../Pages/Blog/ViewBlogDetails";
import ManageSubscription from "../Pages/ManageSubscription";
import AddSubscription from "../Pages/ManageSubscription/addSubscription";
import Refund from "../Pages/Refund";

export const Loadable = (Component) => (props) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};

const Spinner = Loadable(lazy(() => import("../component/Spinner")));
const PageNotFound = Loadable(lazy(() => import("../component/PageNotFound")));
const Dashboard = Loadable(lazy(() => import("../Pages/Dashboard")));
const Login = Loadable(lazy(() => import("../Pages/auth/Login")));
const ForgotPassword = Loadable(
  lazy(() => import("../Pages/auth/ForgotPassword"))
);
const ChangePassword = Loadable(lazy(() => import("../Pages/ChangePassword")));
const AdminProfile = Loadable(lazy(() => import("../Pages/AdminProfile")));
const ManageClient = Loadable(lazy(() => import("../Pages/ManageClient")));
const ViewClientDetails = Loadable(
  lazy(() => import("../Pages/ManageClient/ViewClientDetails"))
);
const EditClient = Loadable(
  lazy(() => import("../Pages/ManageClient/EditClient"))
);
const AppContent = Loadable(lazy(() => import("../Pages/AppContent")));
const ManageFaq = Loadable(lazy(() => import("../Pages/ManageFaq")));
const EditFaq = Loadable(lazy(() => import("../Pages/ManageFaq/EditFaq")));
const ManageContact = Loadable(lazy(() => import("../Pages/ManageContact")));
const Setting = Loadable(lazy(() => import("../Pages/Setting")));
const ManageNotification = Loadable(
  lazy(() => import("../Pages/ManageNotification"))
);
const AddNotification = Loadable(
  lazy(() => import("../Pages/ManageNotification/AddNotification"))
);

const Router = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let { isLoading } = useSelector((state) => state.master);
  let isLogin = Cookies.get("isLoginCA");
  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const MODULE_PATH = location.pathname;
  //console.log('MODULE_PATH :', MODULE_PATH);

  const storedModule = localStorage.getItem("modulePath");
  if (!MODULE_PATH.startsWith(storedModule)) {
    localStorage.removeItem("modulePath");
    localStorage.removeItem("currentPage");
  }

  // console.log("permissions :", permissions);
  // console.log("permissions :", role);
  // console.log("permissions :", permissions[1]?.module_id === 2);
  // console.log("permissions :", permissions[1]?.permission_update === 1);

  //console.log("contex*****************************",permissions);

  //Redirect to login page if the user is not logged in
  useEffect(() => {
    const allowedPaths = [
      "/login",
      "/sign_up",
      "/forgot_password",
      "/about_us_page/en",
      "/privacy_policy_page/en",
      "/terms_and_condition_page/en",
      "/cancellation_and_refund/en",
      "/cancellation_and_refund/ar",
      "/refund/en",
      "/refund/ar",
      "/FAQ/en",
      "/about_us_page/ar",
      "/privacy_policy_page/ar",
      "/terms_and_condition_page/ar",
      "/FAQ/ar",
    ];

    const isForgotPasswordEmailPage = /^\/forgot_password_email\/[^/]+$/.test(
      location.pathname
    );

    if (
      !isLogin &&
      !allowedPaths.includes(location.pathname) &&
      !isForgotPasswordEmailPage
    ) {
      navigate("/login");
    }
  }, [isLogin, location, navigate]);

  <Spinner message="Please Wait..." isActive={isLoading} />;
  if (!isLogin) {
    return (
      <>
        <Spinner message="Please Wait..." isActive={isLoading} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route
            path="/forgot_password_email/:token"
            element={<ForgotPasswordEmail />}
          />
          <Route path="/change_password" element={<ChangePassword />} />
          <Route path="/about_us_page/:lang" element={<AboutUs />} />
          <Route
            path="/privacy_policy_page/:lang"
            element={<PrivacyPolicy/>}
          />
          <Route
            path="/cancellation_and_refund/:lang"
            element={<CancellationAndRefund />}
          />
          <Route
            path="/refund/:lang"
            element={<Refund/>}
          />
          <Route
            path="/terms_and_condition_page/:lang"
            element={<TermsCondition />}
          />
          <Route path="*" element={<Login />} />
          <Route path="/FAQ/:lang" element={<FAQ />} />
        </Routes>
      </>
    );
  } else {
    return (
      <>
        <Spinner message="Please Wait..." isActive={isLoading} />
        <Routes>
          <Route element={<DashboardLayout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/my_account" element={<AdminProfile />} />

            <Route
              path="/manage_client/edit_client"
              element={
                role == "admin" ||
                (permissions[1]?.module_id === 2 &&
                  permissions[1]?.permission_update === 1) ? (
                  <EditClient />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/contect_us_replay" element={<ContectUsReplay />} />

            <Route path="/manage_client" element={<ManageClient />} />

            <Route
              path="/manage_client/view_client_details"
              element={
                role == "admin" ||
                (permissions[1]?.module_id === 2 &&
                  permissions[1]?.permission_view === 1) ? (
                  <ViewClientDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_school" element={<ManageSchool />} />
            <Route
              path="/manage_school/view_school_details"
              element={
                role == "admin" ||
                (permissions[4]?.module_id === 5 &&
                  permissions[4]?.permission_view === 1) ? (
                  <ViewSchoolDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route
              path="/manage_ladder_letter"
              element={<ManageLadderLetter />}
            />
            <Route
              path="/manage_ladder_letter/view_ladder_letter_details"
              element={
                role == "admin" ||
                (permissions[7]?.module_id === 8 &&
                  permissions[7]?.permission_view === 1) ? (
                  <ViewLadderLetterDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_ladder_letter/edit_ladder_letter"
              element={
                role == "admin" ||
                (permissions[7]?.module_id === 8 &&
                  permissions[7]?.permission_update === 1) ? (
                  <EditLadderLetter />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_ladder_letter/add_ladder_letter"
              element={
                role == "admin" ||
                (permissions[7]?.module_id === 8 &&
                  permissions[7]?.permission_add === 1) ? (
                  <AddLadderLetter />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_latter" element={<ManageLatter />} />
            <Route
              path="/manage_latter/view_latter_details"
              element={
                role == "admin" ||
                (permissions[6]?.module_id === 7 &&
                  permissions[6]?.permission_view === 1) ? (
                  <ViewLatterDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_latter/edit_latter"
              element={
                role == "admin" ||
                (permissions[6]?.module_id === 7 &&
                  permissions[6]?.permission_update === 1) ? (
                  <EditLatter />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_latter/add_latter"
              element={
                role == "admin" ||
                (permissions[6]?.module_id === 7 &&
                  permissions[6]?.permission_add === 1) ? (
                  <AddLatter />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            {role === "admin" && (
              <>
                <Route path="/manage_subadmin" element={<ManageSubAdmin />} />
                <Route
                  path="/manage_subadmin/edit_subadmin"
                  element={<EditSubAdmin />}
                />
                <Route
                  path="/manage_subadmin/add_subadmin"
                  element={<AddSubAdmin />}
                />
              </>
            )}

            <Route path="/manage_badge" element={<ManageBadge />} />

            <Route
              path="/manage_badge/edit_badge"
              element={
                role == "admin" ||
                (permissions[11]?.module_id === 12 &&
                  permissions[11]?.permission_update === 1) ? (
                  <EditBadge />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_badge/add_badge"
              element={
                role == "admin" ||
                (permissions[11]?.module_id === 12 &&
                  permissions[11]?.permission_add === 1) ? (
                  <AddBadge />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_blog" element={<ManageBlog />} />
            <Route
              path="/manage_blog/edit_blog"
              element={
                role == "admin" ||
                (permissions[10]?.module_id === 11 &&
                  permissions[10]?.permission_update === 1) ? (
                  <AddBlog />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_blog/view_blog"
              element={
                role == "admin" ||
                (permissions[10]?.module_id === 11 &&
                  permissions[10]?.permission_view === 1) ? (
                  <ViewBlogDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_blog/add_blog"
              element={
                role == "admin" ||
                (permissions[10]?.module_id === 11 &&
                  permissions[10]?.permission_add === 1) ? (
                  <AddBlog />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_teacher" element={<ManageTeacher />} />
            <Route
              path="/manage_teacher/view_teacher_details"
              element={
                role == "admin" ||
                (permissions[2]?.module_id === 3 &&
                  permissions[2]?.permission_view === 1) ? (
                  <ViewTeacherDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_challenge" element={<ManageChallenge />} />
            <Route
              path="/manage_challenge/view_challenge_details"
              element={
                role == "admin" ||
                (permissions[9]?.module_id === 10 &&
                  permissions[9]?.permission_view === 1) ? (
                  <ViewChallengeDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_challenge/edit_challenge"
              element={
                role == "admin" ||
                (permissions[9]?.module_id === 10 &&
                  permissions[9]?.permission_update === 1) ? (
                  <EditChallenge />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_challenge/add_challenge"
              element={
                role == "admin" ||
                (permissions[9]?.module_id === 10 &&
                  permissions[9]?.permission_add === 1) ? (
                  <AddChallenge />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_tournament" element={<ManageTournament />} />

            <Route
              path="/manage_tournament/view_user_details"
              element={
                role == "admin" ||
                (permissions[13]?.module_id === 14 &&
                  permissions[13]?.permission_view === 1) ? (
                  <ViewClientDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_tournament/view_tournament_leaderboard"
              element={<TurnamentLeaderboard />}
            />
            <Route
              path="/manage_tournament/view_tournament_details"
              element={
                role == "admin" ||
                (permissions[13]?.module_id === 14 &&
                  permissions[13]?.permission_view === 1) ? (
                  <ViewTournamentDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_tournament/edit_tournament"
              element={
                role == "admin" ||
                (permissions[13]?.module_id === 14 &&
                  permissions[13]?.permission_update === 1) ? (
                  <EditTournament />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_tournament/add_tournament"
              element={
                role == "admin" ||
                (permissions[13]?.module_id === 14 &&
                  permissions[13]?.permission_add === 1) ? (
                  <AddTournament />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_number" element={<ManageNumber />} />
            <Route
              path="/manage_number/view_number_details"
              element={
                role == "admin" ||
                (permissions[5]?.module_id === 6 &&
                  permissions[5]?.permission_view === 1) ? (
                  <ViewNumberDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_number/edit_number"
              element={
                role == "admin" ||
                (permissions[5]?.module_id === 6 &&
                  permissions[5]?.permission_update === 1) ? (
                  <EditNumber />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_number/add_number"
              element={
                role == "admin" ||
                (permissions[5]?.module_id === 6 &&
                  permissions[5]?.permission_add === 1) ? (
                  <AddNumber />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_word" element={<ManageWord />} />
            <Route
              path="/manage_word/view_word_details"
              element={
                role == "admin" ||
                (permissions[0]?.module_id === 1 &&
                  permissions[0]?.permission_view === 1) ? (
                  <ViewWordDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_word/edit_word"
              element={
                role == "admin" ||
                (permissions[0]?.module_id === 1 &&
                  permissions[0]?.permission_update === 1) ? (
                  <EditWord />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_word/add_word"
              element={
                role == "admin" ||
                (permissions[0]?.module_id === 1 &&
                  permissions[0]?.permission_add === 1) ? (
                  <AddWord />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_sentence" element={<ManageSentence />} />
            <Route
              path="/manage_sentence/view_sentence_details"
              element={
                role == "admin" ||
                (permissions[3]?.module_id === 4 &&
                  permissions[3]?.permission_view === 1) ? (
                  <ViewSentenceDetails />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_sentence/edit_sentence"
              element={
                role == "admin" ||
                (permissions[3]?.module_id === 4 &&
                  permissions[3]?.permission_update === 1) ? (
                  <EditSentence />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />
            <Route
              path="/manage_sentence/add_sentence"
              element={
                role == "admin" ||
                (permissions[3]?.module_id === 4 &&
                  permissions[3]?.permission_add === 1) ? (
                  <AddSentence />
                ) : (
                  <Navigate to={"/not_have_permission"} replace />
                )
              }
            />

            <Route path="/manage_category" element={<ManageCategory />} />
            <Route
              path="/manage_category/view_category_details"
              element={<ViewCategoryDetails />}
            />
            <Route
              path="/manage_category/edit_category"
              element={<EditCategory />}
            />
            <Route
              path="/manage_category/add_category"
              element={<AddCategory />}
            />

            <Route path="/about_us" element={<AppContent />} />
            <Route path="/privacy_policy" element={<AppContent />} />
            <Route path="/terms_and_condition" element={<AppContent />} />
            <Route path="/manage_faq" element={<ManageFaq />} />
            <Route path="/manage_faq/edit_faq" element={<EditFaq />} />
            <Route path="/manage_faq/add_faq" element={<EditFaq />} />

            <Route path="/leaderboard" element={<Leaderboard />} />

            {role === "admin" && (
              <>
                <Route
                  path="/manage_notification"
                  element={<ManageNotification />}
                />
                <Route
                  path="/manage_notification/add_notification"
                  element={<AddNotification />}
                />
                <Route path="/setting" element={<Setting />} />
              </>
            )}

            {role === "admin" && (
              <>
                <Route
                  path="/manage_subscription"
                  element={<ManageSubscription />}
                />
                <Route
                  path="/manage_subscription/add_subscription"
                  element={<AddSubscription />}
                />
              </>
            )}

            <Route path="/manage_contact" element={<ManageContact />} />

            <Route path="/change_password" element={<ChangePassword />} />

            <Route path="*" element={<PageNotFound />} />
            <Route
              path="/not_have_permission"
              element={<PermissionNotHave />}
            />
          </Route>
        </Routes>
      </>
    );
  }
};

export default Router;
